import { DoctoralServicePath } from "utils/constants";

const seats = `${DoctoralServicePath}doctoral-seats`;
const campaigns = `${DoctoralServicePath}doctoral-campaigns`;
const candidacies = `${DoctoralServicePath}doctorant-candidacies`;
const campaignRankings = `${DoctoralServicePath}doctoral-campaign-rankings`;
const enrollments = `${DoctoralServicePath}doctorant-enrollments`;
const doctorants = `${DoctoralServicePath}doctorants`;
const doctoralSchoolCampaigns = `${DoctoralServicePath}doctoral-school-campaigns`;
const doctoralSchoolDoctorants = `${DoctoralServicePath}doctoral-school-doctorants`;

export const doctoralRequests = {
  approveSeatsByFc: () => `${seats}/approve-fc`,
  declineSeatsByFc: () => `${seats}/decline-fc`,
  approveSeatsByAc: () => `${seats}/approve-ac`,
  declineSeatsByAc: () => `${seats}/decline-ac`,
  approveSeatsByMon: () => `${seats}/approve-mon`,
  declineSeatsByMon: () => `${seats}/decline-mon`,
  addCampaignSeat: campaignId => `${campaigns}/${campaignId}/seats`,
  removeCampaignSeat: (campaignId, seatId) => `${campaigns}/${campaignId}/seats/${seatId}`,
  addCampaignDocumentType: campaignId => `${campaigns}/${campaignId}/document-types`,
  updateCampaignDocumentType: (campaignId, documentTypeId) =>
    `${campaigns}/${campaignId}/document-types/${documentTypeId}`,
  removeCampaignDocumentType: (campaignId, documentTypeId) =>
    `${campaigns}/${campaignId}/document-types/${documentTypeId}`,
  getDoctoralDisciplinesSelect: () => `${DoctoralServicePath}selects/doctoral-disciplines`,
  getDoctoralProgramsSelect: () => `${DoctoralServicePath}selects/doctoral-programs`,
  getDoctoralCampaignsSelect: () => `${DoctoralServicePath}selects/doctoral-campaigns`,
  getDoctoralSeatsByCampaignSelect: campaignId =>
    `${DoctoralServicePath}selects/doctoral-seats/by-campaign/${campaignId}`,
  getHigherEducationFieldsSelect: () => `${DoctoralServicePath}selects/higher-education-fields`,
  getDoctoralStudyTypesSelect: () => `${DoctoralServicePath}selects/doctoral-study-types`,
  eligibleSeatsForCampaign: () => `${seats}/eligible-for-campaign`,
  getExamAdmissionCommittee: (campaignId, seatId) =>
    `${campaigns}/${campaignId}/seats/${seatId}/exam-admission-committee`,
  createExamAdmissionCommittee: (campaignId, seatId) =>
    `${campaigns}/${campaignId}/seats/${seatId}/exam-admission-committee`,
  updateExamAdmissionCommittee: (campaignId, seatId) =>
    `${campaigns}/${campaignId}/seats/${seatId}/exam-admission-committee`,
  deleteExamAdmissionCommittee: (campaignId, seatId) =>
    `${campaigns}/${campaignId}/seats/${seatId}/exam-admission-committee`,
  scheduleExam: (campaignId, disciplineId) => `${campaigns}/${campaignId}/exams/${disciplineId}/schedule`,
  setExamCommittee: (campaignId, disciplineId) => `${campaigns}/${campaignId}/exams/${disciplineId}/committee`,
  approveExamCommittee: (campaignId, disciplineId) =>
    `${campaigns}/${campaignId}/exams/${disciplineId}/committee/approve`,
  enterExamGrade: campaignId => `${campaigns}/${campaignId}/exam-grades`,
  getLanguageExams: campaignId => `${campaigns}/${campaignId}/language-exams`,
  setLanguageExamCommittee: (campaignId, languageId) =>
    `${campaigns}/${campaignId}/language-exams/${languageId}/committee`,
  scheduleLanguageExam: (campaignId, languageId) =>
    `${campaigns}/${campaignId}/language-exams/${languageId}/schedule`,
  getCandidacyExamGrades: id => `${candidacies}/${id}/exam-grades`,
  approveCandidacy: id => `${candidacies}/${id}/approve`,
  declineCandidacy: id => `${candidacies}/${id}/decline`,
  getCandidacyActions: id => `${candidacies}/${id}/actions`,
  claimCandidacy: id => `${candidacies}/${id}/claim`,
  releaseCandidacy: id => `${candidacies}/${id}/release`,
  availableCandidacySeats: id => `${candidacies}/${id}/available-seats`,
  addCandidacySeat: id => `${candidacies}/${id}/seats`,
  removeCandidacySeat: (id, seatId) => `${candidacies}/${id}/seats/${seatId}`,
  reorderCandidacySeats: id => `${candidacies}/${id}/seats/priorities`,
  createCampaignRanking: campaignId => `${campaigns}/${campaignId}/ranking`,
  campaignRankingsByCampaign: campaignId => `${campaignRankings}?campaignId=${campaignId}`,
  campaignRanking: id => `${campaignRankings}/${id}`,
  generateCampaignRankingDraft: id => `${campaignRankings}/${id}/generate-draft`,
  approveCampaignRanking: id => `${campaignRankings}/${id}/approve`,
  exportCampaignRanking: id => `${campaignRankings}/${id}/export`,
  getCampaignRankingSummary: (rankingId, seatId) => `${campaignRankings}/${rankingId}/summary/${seatId}`,
  getCampaignRankingResults: (rankingId, seatId) => `${campaignRankings}/${rankingId}/results/${seatId}`,
  getApprovedCandidacies: () => `${campaignRankings}/approved-candidacies`,
  getDoctorantEnrollment: (candidacyId, seatId) =>
    `${enrollments}?doctorantCandidacyId=${candidacyId}&doctoralSeatId=${seatId}`,
  enrollDoctorant: () => enrollments,
  interruptDoctorant: doctorantId => `${doctorants}/${doctorantId}/interrupt`,
  reinstateDoctorant: doctorantId => `${doctorants}/${doctorantId}/reinstate`,
  addDoctorantDocument: doctorantId => `${doctorants}/${doctorantId}/documents`,
  addCandidacyDocument: candidacyId => `${candidacies}/${candidacyId}/documents`,
  addDoctorantReport: doctorantId => `${doctorants}/${doctorantId}/reports`,
  dismissDoctorantWithRightToDefend: doctorantId =>
    `${doctorants}/${doctorantId}/dismiss-with-right-to-defend`,
  dismissDoctorantWithoutRightToDefend: doctorantId =>
    `${doctorants}/${doctorantId}/dismiss-without-right-to-defend`,
  updateDoctorantTopic: doctorantId => `${doctorants}/${doctorantId}/topic`,
  updateDoctorantSupervisors: doctorantId => `${doctorants}/${doctorantId}/supervisors`,
  updateDoctorantPersonalInfo: doctorantId => `${doctorants}/${doctorantId}/personal-info`,
  updateDoctorantPreviousEducation: doctorantId => `${doctorants}/${doctorantId}/previous-education`,
  getDoctorantDefense: doctorantId => `${doctorants}/${doctorantId}/defense`,
  saveDoctorantDefenseJury: doctorantId => `${doctorants}/${doctorantId}/defense/jury`,
  scheduleDoctorantDefense: doctorantId => `${doctorants}/${doctorantId}/defense/schedule`,
  recordDoctorantDefenseResult: doctorantId => `${doctorants}/${doctorantId}/defense/result`,
  doctoralSchoolDoctorants: () => doctoralSchoolDoctorants,
  createDoctoralSchoolDoctorantFromDoctorant: () => `${doctoralSchoolDoctorants}/from-doctorant`,
  createExternalDoctoralSchoolDoctorant: () => `${doctoralSchoolDoctorants}/external`,
  createTeacherDoctoralSchoolDoctorant: () => `${doctoralSchoolDoctorants}/teacher`,
  setDoctoralSchoolCertificate: doctorantId => `${doctoralSchoolDoctorants}/${doctorantId}/certificate`,
  recordDoctoralSchoolResult: doctorantId => `${doctoralSchoolDoctorants}/${doctorantId}/result`,
  doctoralSchoolClasses: campaignId => `${doctoralSchoolCampaigns}/${campaignId}/classes`,
  doctoralSchoolClass: (campaignId, classId) => `${doctoralSchoolCampaigns}/${campaignId}/classes/${classId}`,
};
